import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbsDownFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 4.95833V11.3127C3.75 11.6923 4.05771 12 4.43729 12C4.59624 12 4.73445 11.891 4.77148 11.7364L5.15998 10.1149C5.17826 10.0386 5.1875 9.96035 5.1875 9.88188V4.47917C5.1875 4.21453 4.97297 4 4.70833 4C4.17906 4 3.75 4.42906 3.75 4.95833Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.084 16.4214L8.64078 12.1724C8.57713 12.0617 8.55824 11.9308 8.58799 11.8066L8.7181 11.2636C8.91922 10.4241 9.02083 9.56389 9.02083 8.70068V5C9.02083 4.44772 9.46855 4 10.0208 4H12.1819C13.4476 4 14.5771 4.79432 15.0052 5.9854L16.3491 9.72506C16.7472 10.8327 15.9263 12 14.7493 12H11.0744C11.0067 12 10.9585 12.0657 10.9793 12.1302C11.462 13.6241 12.0946 15.3347 11.7484 16.4277C11.6476 16.7457 11.2503 16.7106 11.084 16.4214Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 4.95833V11.3127C3.75 11.6923 4.05771 12 4.43729 12C4.59624 12 4.73445 11.891 4.77148 11.7364L5.15998 10.1149C5.17826 10.0386 5.1875 9.96035 5.1875 9.88188V4.47917C5.1875 4.21453 4.97297 4 4.70833 4C4.17906 4 3.75 4.42906 3.75 4.95833Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.084 16.4214L8.64078 12.1724C8.57713 12.0617 8.55824 11.9308 8.58799 11.8066L8.7181 11.2636C8.91922 10.4241 9.02083 9.56389 9.02083 8.70068V5C9.02083 4.44772 9.46855 4 10.0208 4H12.1819C13.4476 4 14.5771 4.79432 15.0052 5.9854L16.3491 9.72506C16.7472 10.8327 15.9263 12 14.7493 12H11.0744C11.0067 12 10.9585 12.0657 10.9793 12.1302C11.462 13.6241 12.0946 15.3347 11.7484 16.4277C11.6476 16.7457 11.2503 16.7106 11.084 16.4214Z",
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export default SvgThumbsDownFilled;
